import { useEffect } from "react"
import { useRecoilState } from "recoil"
import { applicationSummariesState, hasFetchedInitialApplications } from "state"
import { ApplicationSummaryEnhanced } from "models/ApplicationSummaryEnhanced"
import { GetAllApplications } from "lib/Applications"
import { ErrorCode } from "../ApplicationError"
import { useHandleError } from "hooks/useHandleError"
import { useSession } from "lib/auth/react"

export function useApplicationSummaries() {
  const { data } = useSession()
  const [hasFetchedSummaries, setHasFetchedSummaries] = useRecoilState<boolean>(
    hasFetchedInitialApplications
  )
  const [applicationSummaries, setApplications] =
    useRecoilState<ApplicationSummaryEnhanced[]>(applicationSummariesState)
  const { HandleError } = useHandleError()

  async function refreshApplications(invalidateCache = true) {
    if (isFetchingSummaries) {
      return
    }

    isFetchingSummaries = true

    try {
      const allApplications = await GetAllApplications(invalidateCache)
      setApplications(allApplications)
      setHasFetchedSummaries(true)
    } catch (err) {
      HandleError(ErrorCode.FetchingAllApplications, err, false)
    } finally {
      isFetchingSummaries = false
    }
  }

  useEffect(() => {
    if (!hasFetchedSummaries && data) {
      refreshApplications(true)
    }
  }, [hasFetchedSummaries, data])

  return { applicationSummaries, hasFetchedSummaries, refreshApplications }
}

// Blocks parallel requests to fetch all application summaries
let isFetchingSummaries = false
